// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"2999356e","323":"5479be88","391":"6807984f","436":"6a257bd0","453":"abd36b29","691":"99175f53","747":"c56c9dd9"}[chunkId] + ".chunk.js";
};